import actionCreatorFactory from "../util/redux/action-factory";
import { BulletinDto } from "../util/DTOs/BulletinDtos";
import { ReduxDispatch, ReduxState } from "./reducers";
import * as request from "../util/request";
import { env } from "../util/env";
import { showSnackbar } from "./snackbar";
import logger from "../util/logger";
import { reducerWithInitialState } from "../util/redux/typed-reducers";

const actionFactory = actionCreatorFactory("HypoMobiili/Bulletins");

const getBulletinsAction = actionFactory<{}, BulletinDto[], string>(
    "GET_BULLETINS"
);

export interface Bulletins {
    [key: number]: BulletinDto;
}

export class BulletinsState {
    bulletins: Bulletins;
    loading: boolean;
}

const initialBulletinsState: BulletinsState = {
    bulletins: {},
    loading: false,
};

export function getBulletins() {
    return async (dispatch: ReduxDispatch) => {
        try {
            dispatch(getBulletinsAction({}));

            const result = await request.get<BulletinDto[]>(
                `${env.APP_API_HOST}/api/portaali/bulletins`
            );

            dispatch(getBulletinsAction.done(result));
        } catch (error) {
            dispatch(getBulletinsAction.failed("Error fetching bulletins"));
            dispatch(showSnackbar("Tiedotteiden hakeminen epäonnistui"));
            logger.error(error);
            throw error;
        }
    };
}

export const BulletinsReducer = reducerWithInitialState(initialBulletinsState)
    .case(getBulletinsAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getBulletinsAction.done, (state, action) => {
        const bulletins = action.payload as BulletinDto[];

        state.bulletins = bulletins.reduce((acc, bull) => {
            return {
                ...acc,
                [bull.id]: {
                    ...bull,
                },
            };
        }, {});

        return {
            ...state,
            loading: false,
        };
    })
    .case(getBulletinsAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    });

export default BulletinsReducer;

export const getBulletinsFromState = (state: ReduxState) => {
    return state && state.bulletins.bulletins;
};

export const getBulletinById = (state: ReduxState, bulletinId: number) => {
    return state.bulletins.bulletins[bulletinId];
};

export const bulletinsLoading = (state: ReduxState) => {
    return state.bulletins.loading;
};



// WEBPACK FOOTER //
// ./src/ducks/bulletins.ts